<template>
    <div class="privilege-list">
        <div class="privilege-item"
            v-for="(campaign,k) in list"
            :key="k"
            @click="clickCampaign(campaign)">
            <div class="img-product">
                <img :src="campaign.fullImageUrl" class="img-fluid"/>
            </div>
            <div class="content-privilege">
                <div class="text-name">{{campaign.name}}</div>
                <div v-html="getPointText(campaign.pointPerUnit, campaign.pointType)"></div>
            </div>
        </div>
    </div>
</template>
<script>
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
//helper
import Util from "@/helper/Utility.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
export default {
    name: "PrivilegeList",
    mixins: [LocaleMixin],
    props: {
        list: Array,
        isLoaded: Boolean
    },
    data: function() {
        return {
            trackingService: new TrackingService(this),
        };
    },
    methods: {
        clickCampaign: function (campaign) {
            this.trackingService.event('campaigndetail_page', 'click_to_campaigndetail', null, null);
            
            var path = "/privilege/" + campaign.id;
            this.$router.push(path);
        },
        getPointText: function (point, pointType) {
            var pointTypeTxt = pointType && pointType != 'use'
                            ? this.lbl.campaign.get_point
                            : this.lbl.campaign.use_point;

            var pointUnit = this.locale === 1033 && point > 1
                        ? this.lbl.campaign.point + 's'
                        : this.lbl.campaign.point;

            return `<div class="text-point">${pointTypeTxt} <span class="points">${Util.formatNum(point)}</span> ${pointUnit}</div>`;
        }
    },
}
</script>
<style lang="scss">
@import "@/style/base/common.scss";

.privilege-list{
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;

    .privilege-item {
        @include boxShadow(#ffffff, 0.5px, 229, 229, 229);
        border: none;
        width: 100%;
        border-radius: 8px;
        line-height: 1;

        .img-product{
            position: relative;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: 50%;
            overflow: hidden;
            border-radius: 4px 4px 0 0;

            img {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
            }

            &:before {
                position: relative;
                content: "";
                display: block;
                padding-top: 66.67%;
            }
        }

        .content-privilege {
            padding: 8px;
        }

        .text-name{
            @extend %ellipsis-2;
            font-size: 1.5rem;
            margin-bottom: 8px;
            color: $a-gray-333333;
            height: 50px;
        }
        .text-point{
            font-size: 1.6rem;
            color: $a-gray-575757;

            .points {
                color: $green-00987F;
                font-weight: 600;
            }
        }
    }
}

</style>
